export const getMessages = state => state.messages;
